/* Renova Build — Apple-style homepage behaviour.
   Scroll reveals + horizontal rail controls. Progressive enhancement only. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var items = (root || document).querySelectorAll('.rnv-reveal:not(.is-in)');
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-rnv-delay') || '0', 10);
          setTimeout(function () { el.classList.add('is-in'); }, delay);
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  function rails(root) {
    var els = (root || document).querySelectorAll('[data-rnv-rail]');
    els.forEach(function (rail) {
      if (rail.dataset.rnvRailReady === '1') return;
      rail.dataset.rnvRailReady = '1';

      var track = rail.querySelector('[data-rnv-rail-track]');
      var prev = rail.querySelector('[data-rnv-rail-prev]');
      var next = rail.querySelector('[data-rnv-rail-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('[data-rnv-rail-item]');
        return card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' });
      });

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function init(root) { reveal(root); rails(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-run inside the theme editor when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();
